import useBackboneCollection from '@netx/core-components/hooks/useBackboneCollection';
import useBackboneModel from '@netx/core-components/hooks/useBackboneModel';
import {session} from '@netx/core-auth/collections/singleton/session';

export const useSession = () => {
	const samlServices = useBackboneCollection(
		session.get('samlServices')!,
		false,
	);
	// @ts-ignore
	const data = useBackboneModel(session, false);
	return {
		data,
		sessionExpired: session.sessionExpired.bind(session),
		samlServices: samlServices,
		setCookie: session.setCookie.bind(session),
		setKey: session.setKey.bind(session),
	};
};

export default useSession;
